import D2C_TariffPlan from './Plan'

class D2C_TariffPersonal extends D2C_TariffPlan {
  icon = 'user tie'
  isPersonal = true
  static objectType = 'tariffType'
  static active = true
  static tariffId = '5b9f4e6cb42e24e06a258519'
  static tariffTitle = 'Personal'
  static order = 30
}

export default D2C_TariffPersonal
